/**
@format
@flow local-strict
*/
import React from 'react';
import styled from 'styled-components';
import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';
import Link from '@ziynx/components/links';
import ListItem from '@ziynx/components/listItems';
import List from '@ziynx/components/lists';
import { Line } from '@ziynx/components/lines';
import type { ViewportType } from '@ziynx/flow-types/viewports';
import type { ListItem as ListItemType } from '@ziynx/flow-types/listItems';

type Props = $ReadOnly<{|
  /**
   * Viewports
   */
  viewport?: ViewportType,
  /**
   * Content array of object passed
   */
  content: Array<ListItemType>,
  /**
   * If NavList is collapsed
   */
  isCollapsed?: boolean,
  /**
   * Width for list
   * Default to inherit from parent
   */
  width?: string,
  /**
   * Max-width for list, optional
   * Default to inherit from parent
   */
  maxWidth?: string,
  /**
   * Delivers a callback to App Manager for delegation to other components.
   */
   sideNavAppHandler?: Function,

|}>;

const LinkWrapper = styled.div``;

const LineWrapper = styled.div`
  margin-bottom: 24px;
  margin-top: 12px;
`;

const SideNavList = (props: Props): React$Node => {
  const {
    content,
    width,
    maxWidth,
    isCollapsed,
    viewport,
    sideNavAppHandler,
    ...rest
  } = props;

  const location = useLocation();

  const renderListItem = (): React$Node => content.map((item: ListItemType, index: number) => {
    const keyIndex = `${index}`;

    const { hasSeparator } = item;

    const handleIsActive = (match: Object): boolean => {
      if (match?.isExact && !item?.disabled) return true;

      return false;
    };

    const itemMatch = !!matchPath(location?.pathname, item?.path);

    const isDesktop = viewport === 'desktop';

    const handleSideNav = () => {
      if (!isDesktop && sideNavAppHandler) sideNavAppHandler(false);
    };

    return (
      <div key={`${keyIndex + 2}list-item`}>
        { hasSeparator && (
          // eslint-disable-next-line prefer-template
          <LineWrapper key={keyIndex + 'spearator'}>
            <Line />
          </LineWrapper>
        ) }
        <LinkWrapper onClick={handleSideNav} key={keyIndex}>
          <Link
            variant="navigation"
            activeOnlyWhenExact
            key={keyIndex}
            to={item?.path}
            isActive={handleIsActive}
          >
            <ListItem
              variant="squircle"
              key={keyIndex}
              size="small"
              isCollapsed={isCollapsed}
              isSelected={itemMatch}
              disabled={item?.disabled}
              label={item?.label}
              text={item?.text || ''}
              iconName={item?.iconName}
              imageSource={item?.imageSource}
              imageAltText={item?.imageAltText}
              squircleText={item?.squircleText}
              maxWidth="100%"
            />
          </Link>
        </LinkWrapper>
      </div>
    );
  });

  return (
    <List
      {...rest}
      variant="squircle"
      width={width}
      maxWidth={maxWidth}
      renderListItem={renderListItem}
    />
  );
};

export default SideNavList;
